<ejs-toast (created)="onCreate()"
           (close)="toastService.remove(toast)"
           (click)="closeToast($event)"
           [showCloseButton]="true"
           [position]="position"
           [style]="'margin-top: ' + (100 * index - 1) + 'px'">
  <ng-template #title>
    <h5 class="d-flex align-items-center">
      @if (toast.type === 'error' || toast.type === 'warning') {
        <span class="e-icons icon-warning"></span>
      }
      @if (toast.type === 'success') {
        <span class="e-icons icon-checkmark--outline"></span>
      }
      <strong class="mx-1">{{ toast.header | translate }}</strong>
    </h5>
  </ng-template>
  <ng-template #content>
    @if (isTemplate(toast)) {
      <ng-template [ngTemplateOutlet]="toast.textOrTpl"></ng-template>
    } @else {
      <div innerHTML="{{ toast.textOrTpl | translate:{placeholder: toast.placeholder} }}"></div>
      @if (toast.errorDetail) {
        <div class='error-detail'>
          <div innerHTML="{{ 'i18n.errors.details' | translate }}:"></div>
          <div innerHTML="{{ toast.errorDetail | translate }}"></div>
        </div>
      }
    }

  </ng-template>
</ejs-toast>
